import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRemoteConfig } from '_/context/RemoteConfigContext';

import { CircularLoading } from 'junto-ui';
import { BonusJournetAPI } from '@services/api';
import { GTMServices } from '@services/gtm';
import {
  getLastCampaingBonusJourney,
  updateTermAcceptBonusJourney
} from '@plataforma/utils';
import PurpleStarIcon from '../../../../assets/images/purple-star-icon.svg';
import WhiteStarIcon from '../../../../assets/images/white-star-icon.svg';
import {
  Container,
  Header,
  Star,
  Logo,
  Title,
  Text,
  Checkbox,
  Button
} from './styles';

export const BonusJourneyTerms = ({ toggleModal, setToast }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [remoteState] = useRemoteConfig();
  const { regulationLink } = remoteState.config.bonusJourneyConfig;
  const getHtml = () => {
    return `<p>Li e concordo com o <a href='${regulationLink}' target='blank'><strong>Regulamento</strong></a></p>`;
  };

  useEffect(() => {
    GTMServices.dispatchGtm(
      'Jornada Bônus - 2024',
      'Processos',
      'Modal aceite termos - Visualizou'
    );
  }, []);

  const acceptBonusJourneyTerm = useCallback(async () => {
    setLoading(true);
    try {
      const { campaignId } = await getLastCampaingBonusJourney();

      await BonusJournetAPI.postTermAccpet(campaignId);
      await updateTermAcceptBonusJourney(true);
      GTMServices.dispatchGtm(
        'Jornada Bônus - 2024',
        'Processos',
        'Modal aceite termos - Aceitou Termo'
      );
      toggleModal('bonusJourneyTerms');
    } catch (err) {
      setToast(prev => ({
        ...prev,
        open: true,
        type: 'bonusJourney'
      }));
    } finally {
      setLoading(false);
    }
  }, [setToast, toggleModal]);

  return (
    <Container>
      <Header>
        <Logo
          src="https://static.juntoseguros.com/images/trilha-de-incentivo-logo-inverse.svg"
          alt="Logo da trilha de incentivo"
        />
        <Star src={PurpleStarIcon} width={16.45} height={16.45} />
        <Star src={WhiteStarIcon} width={11} height={11} />
        <Star src={PurpleStarIcon} width={6} height={6} />
        <Star src={WhiteStarIcon} width={8} height={8} />
        <Star src={WhiteStarIcon} width={8} height={8} />
        <Star src={WhiteStarIcon} width={9} height={9} />
        <Star src={WhiteStarIcon} width={6} height={6} />
        <Star src={PurpleStarIcon} width={9} height={9} />
        <Star src={PurpleStarIcon} width={12} height={12} />
      </Header>
      <Title>Chegou a hora de transformar as suas emissões em bônus.</Title>
      <Text>
        Atinja suas metas de produção e seja recompensado em dinheiro!
      </Text>
      <Checkbox
        id="BonusJourneyTermsModalCheckBox"
        hasError=""
        html={getHtml()}
        onChange={() => setIsChecked(!isChecked)}
        checked={isChecked}
        data-testid="BonusJourneyTerms-checkbox-accept-term"
      />
      <Button
        id="bonus-journey-terms-modal-accepted-term"
        type="button"
        variant="outlined"
        size="big"
        onClick={() => acceptBonusJourneyTerm()}
        disabled={!isChecked}
        data-testid="BonusJourneyTerms-button-post-accept-term"
      >
        {loading ? <CircularLoading size={20} /> : 'Participar agora'}
      </Button>
    </Container>
  );
};

BonusJourneyTerms.propTypes = {
  toggleModal: PropTypes.func,
  setToast: PropTypes.func
};
